import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20cozy%20family%20living%20room%20with%20soft%20natural%20light%20streaming%20through%20large%20windows%20modern%20minimalist%20interior%20beige%20cream%20and%20warm%20terracotta%20tones%20peaceful%20harmonious%20atmosphere%20elegant%20but%20lived%20in%20feel%20editorial%20photography%20style%20with%20gentle%20textures%20and%20organic%20composition&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="温馨家庭氛围"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 md:mb-6 leading-tight tracking-tight">
          {siteConfig.name}
        </h1>
        <p className="text-base md:text-xl text-white/90 mb-4 max-w-2xl mx-auto leading-relaxed">
          {siteConfig.tagline}
        </p>
        <p className="text-sm md:text-base text-white/75 mb-8 max-w-xl mx-auto leading-relaxed">
          深度探讨代际关系、婆媳相处、情感边界与沟通技巧，帮助您建立和谐健康的家庭关系
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/xiangchu-zhidao"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-white/20 backdrop-blur-sm text-white border border-white/30 font-medium text-sm hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}